
import { Vue, Component, Prop } from 'vue-property-decorator';
import { avaliacaoStore } from '@/store';

@Component
export default class ChangeStatus extends Vue {
  @Prop({ type: Number }) readonly propIdAvaliacao;

  isLoading: boolean = false;
  dialog: boolean = false;
  status = [
    {
      name: 'Avaliação Supervisor para Pendente',
      new_status: 1,
    },
    {
      name: 'Avaliação Gerente para Pendente',
      new_status: 2,
    },
  ];

  statusSelect = null;

  async changeStatus() {
    let avaliacao_in = {
      id: this.propIdAvaliacao,
      change_status: this.statusSelect,
    };

    try {
      this.isLoading = true;
      await avaliacaoStore.updateAvaliacaoChangeStatus(avaliacao_in);
      this.dialog = false;
      this.isLoading = false;
      this.$emit('statusChanged');
    } catch (error) {
      console.error(error);
      this.isLoading = false;
    }
  }

  mounted() {}
}
